import { render, staticRenderFns } from "./cloudflare-pages.vue?vue&type=template&id=ef0600e2&"
import script from "./cloudflare-pages.vue?vue&type=script&lang=js&"
export * from "./cloudflare-pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports